import { SVGPropsIcon } from 'src/types';

export const AccountIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className={`${props.className} mr-1 text-ga_text h-10 w-10`}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};

export const AccountForProfile = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 24.375C19.2822 24.375 24.375 19.2822 24.375 13C24.375 6.71776 19.2822 1.625 13 1.625C6.71776 1.625 1.625 6.71776 1.625 13C1.625 19.2822 6.71776 24.375 13 24.375ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67892 15.7146C8.4257 15.0119 9.42854 14.625 10.4646 14.625H15.5354C16.5715 14.625 17.5743 15.0119 18.3211 15.7146C19.0695 16.4189 19.5 17.3851 19.5 18.4038V19.5C19.5 19.9487 19.1362 20.3125 18.6875 20.3125C18.2388 20.3125 17.875 19.9487 17.875 19.5V18.4038C17.875 17.8491 17.6413 17.3063 17.2074 16.898C16.7719 16.4882 16.1713 16.25 15.5354 16.25H10.4646C9.82874 16.25 9.22806 16.4882 8.79256 16.898C8.35872 17.3063 8.125 17.8491 8.125 18.4038V19.5C8.125 19.9487 7.76123 20.3125 7.3125 20.3125C6.86377 20.3125 6.5 19.9487 6.5 19.5V18.4038C6.5 17.3851 6.93048 16.4189 7.67892 15.7146Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6.5C11.6538 6.5 10.5625 7.59131 10.5625 8.9375C10.5625 10.2837 11.6538 11.375 13 11.375C14.3462 11.375 15.4375 10.2837 15.4375 8.9375C15.4375 7.59131 14.3462 6.5 13 6.5ZM8.9375 8.9375C8.9375 6.69384 10.7563 4.875 13 4.875C15.2437 4.875 17.0625 6.69384 17.0625 8.9375C17.0625 11.1812 15.2437 13 13 13C10.7563 13 8.9375 11.1812 8.9375 8.9375Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const GameHeaderAccountIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none">
      <g clipPath="url(#clip0_18646_91564)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 38C29.665 38 37.5 30.165 37.5 20.5C37.5 10.835 29.665 3 20 3C10.335 3 2.5 10.835 2.5 20.5C2.5 30.165 10.335 38 20 38ZM20 40.5C31.0457 40.5 40 31.5457 40 20.5C40 9.45431 31.0457 0.5 20 0.5C8.95431 0.5 0 9.45431 0 20.5C0 31.5457 8.95431 40.5 20 40.5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8137 24.6763C12.9626 23.5952 14.5055 23 16.0994 23H23.9006C25.4945 23 27.0374 23.5952 28.1863 24.6763C29.3377 25.7599 30 27.2463 30 28.8135V30.5C30 31.1904 29.4404 31.75 28.75 31.75C28.0596 31.75 27.5 31.1904 27.5 30.5V28.8135C27.5 27.9601 27.1404 27.125 26.473 26.4969C25.803 25.8664 24.8789 25.5 23.9006 25.5H16.0994C15.1211 25.5 14.197 25.8664 13.527 26.4969C12.8596 27.125 12.5 27.9601 12.5 28.8135V30.5C12.5 31.1904 11.9404 31.75 11.25 31.75C10.5596 31.75 10 31.1904 10 30.5V28.8135C10 27.2463 10.6623 25.7599 11.8137 24.6763Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10.5C17.9289 10.5 16.25 12.1789 16.25 14.25C16.25 16.3211 17.9289 18 20 18C22.0711 18 23.75 16.3211 23.75 14.25C23.75 12.1789 22.0711 10.5 20 10.5ZM13.75 14.25C13.75 10.7982 16.5482 8 20 8C23.4518 8 26.25 10.7982 26.25 14.25C26.25 17.7018 23.4518 20.5 20 20.5C16.5482 20.5 13.75 17.7018 13.75 14.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_18646_91564">
          <rect width="40" height="40" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
